// Map of customer subdomains to their Facebook Pixel IDs
// TODO: Later this should be fetched from the backend
const customerPixelMap: Record<string, string> = {
  killerbody: "813606730510301",
};

export default customerPixelMap;
